{
  "info": "資訊",
  "negative": "錯誤",
  "notice": "警告",
  "positive": "成功"
}
